import { useMutation, useQueryClient } from '@tanstack/react-query';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import { CompanyHotelQueryKeys } from '@app/model/company_hotel/service/CompanyHotelQueryKeys';
import { CompanyHotelSettingsService } from '@app/model/company_hotel/service/CompanyHotelSettingsService';

export function useSaveHiddenPricingRoomRateTypesMutation(onError: () => void) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: CompanyHotelSettingsService.saveHiddenPricingRoomRateTypes,
		onMutate: async ({ companyHotelId, rateTypes }) => {
			const key = CompanyHotelQueryKeys.detail(companyHotelId);
			await queryClient.cancelQueries({ queryKey: key });
			const previous = queryClient.getQueryData<CompanyHotel>(key);
			queryClient.setQueryData<CompanyHotel>(key, current => current && withHiddenRateTypes(current, rateTypes));
			return previous;
		},
		onError: (_error, { companyHotelId }, previous) => {
			if (previous) queryClient.setQueryData(CompanyHotelQueryKeys.detail(companyHotelId), previous);
			onError();
		},
		onSuccess: (settings, { companyHotelId }) => {
			queryClient.setQueryData<CompanyHotel>(CompanyHotelQueryKeys.detail(companyHotelId), current => {
				if (!current) return current;
				const updated = new CompanyHotel(current);
				updated.priceRecommendationSettings = settings;
				return updated;
			});
		},
	});
}

function withHiddenRateTypes(current: CompanyHotel, rateTypes: string[]): CompanyHotel {
	const updated = new CompanyHotel(current);
	updated.priceRecommendationSettings = { ...current.priceRecommendationSettings, hiddenPricingRoomRateTypes: rateTypes };
	return updated;
}
